<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :title="title"
      :has-form="true"
      class="time-event-dialog-modal"
      top="15%"
      width="600px"
      @close="close"
      @confirm="handleConfirm"
      append-to-body
    >
      <div v-if="step === 1">
        <gs-radio-group style="margin-left: 3%" v-model="selectedCamera">
          <gs-radio
            v-for="(item, index) in cameraList"
            :key="index"
            :label="item"
            >{{ item.cameraName }}</gs-radio
          >
        </gs-radio-group>

        <el-pagination
          v-model="pageNo"
          :total="total"
          layout="prev, pager, next"
          :page-size="pageSize"
          @current-change="getCameraList"
        />
      </div>

      <gs-form
        v-if="step === 2"
        label-width="60px"
        label-position="left"
        gap="small"
      >
        <gs-form-item label="名称" prop="name" class="form-item-radio">
          <gs-input ref="nameInput" v-model="name" />
        </gs-form-item>

        <gs-form-item label="描述" prop="description" class="form-item-radio">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="description"
          >
          </el-input>
        </gs-form-item>
      </gs-form>

      <div v-if="isEdit">
        <gs-form label-width="60px" label-position="left" gap="small">
          <gs-form-item label="海康平台名称" class="form-item-radio">
          </gs-form-item>
          <gs-form-item label="摄像头区域" class="form-item-radio">
          </gs-form-item>
          <gs-form-item label="摄像头编码" class="form-item-radio">
          </gs-form-item>
          <gs-form-item label="摄像头机型" class="form-item-radio">
          </gs-form-item>
          <gs-form-item label="摄像头类型" class="form-item-radio">
          </gs-form-item>
          <gs-form-item label="状态" class="form-item-radio"></gs-form-item>
        </gs-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm"
          >确 定</gs-button
        >
        <gs-button type="primary" size="mini" @click="beforeClose"
          >取 消</gs-button
        >
      </span>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";

import EventBus from "@/components/eventBus.js";
export default {
  data() {
    return {
      loading: false,
      name: "",
      description: "",
      isEdit: false,
      cameraList: [],
      pageNo: 1,
      pageSize: 10,
      selectedCamera: {},
      total: 0,
      step: 1,
      title: "",
    };
  },
  computed: {
    ...mapState({
      visible: "hkvideoShow",
      nodeData: "nodeTree",
      objectData: "objectInfo",
    }),
  },
  watch: {
    visible() {
      if (this.visible) {
        if (!this.isEdit) {
          this.title = "选择摄像头";
          this.getCameraList();
        } else {
          setTimeout(() => {
            this.$refs.nameInput.focus();
          }, 100);
        }

        if (
          this.objectData &&
          JSON.stringify(this.objectData) !== "{}" &&
          this.objectData.type === "HIKSCamera"
        ) {
          service.getNode(this.objectData.id).then((res) => {
            this.isEdit = true;
            this.title = res.name + `-属性`;
            this.name = res.name;
            this.description = res.description;
          });
        } else {
          this.isEdit = false;

          this.description = "";
          this.name = "";
        }
      } else {
        this.isEdit = true;

        this.description = "";
        this.name = "";
      }
    },
  },
  methods: {
    ...mapMutations({
      close: "HKVIDEO_HIDE",
    }),
    //主
    beforeClose() {
      this.close();
    },
    handleConfirm() {
      if (this.step == 1) {
        if (!this.selectedCamera.cameraIndexCode) {
          return this.$message.warning("请选择摄像头！");
        }
        this.title = "新建-摄像头";
        this.step = 2;
        return;
      }
      if (!this.name) {
        return this.$message.warning("请输入名称！");
      }

      let obj = {
        name: this.name,
        description: this.description,
        type: "HIKSCamera",
        parentId: this.nodeData.id,
        regionIndexCode: this.selectedCamera.regionIndexCode,
        cameraIndexCode: this.selectedCamera.cameraIndexCode,
        cameraTypeName: this.selectedCamera.cameraTypeName,
        cameraName: this.selectedCamera.cameraName,
        cameraTypeCode: this.selectedCamera.cameraTypeCode,
        status: this.selectedCamera.status,
        children: [],
      };
      if (this.isEdit) {
        obj.id = this.objectData.id;
        service
          .editPoint(obj)
          .then((res) => {
            this.$message.success("修改成功");
            this.close();
            EventBus.$emit("refresh");
          })
          .catch((err) => {
            this.$message.error("创建失败");
          });
      } else {
        service
          .newAddPoint(obj)
          .then((res) => {
            this.$message.success("创建成功");
            this.close();
            EventBus.$emit("refresh");
          })
          .catch((err) => {
            this.$message.error("创建失败");
          });
      }
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === "") {
        this.$Message.warning("名称不能为空!");
        return;
      }
      done();
    },

    beforeCloseAdd() {
      this.visibleAdd = false;
    },

    closeAdd() {
      this.visibleAdd = false;
    },

    getCameraList(pageNo) {
      if (!pageNo) {
        this.pageNo = 1;
      } else {
        this.pageNo = pageNo;
      }
      service
        .getCameraList({
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.cameraList = res.list;
          this.total = res.total;
        });
    },
  },
};
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped>
.addTree {
  cursor: pointer;
  color: rgb(248, 121, 1);
}

.inp >>> .gs-input,
.gs-input-number {
  height: 26px;
}

.gs-modal-wrap {
  top: 11%;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  width: 100%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 250px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.form-item-objectSeries >>> .gs-form-item {
  margin-bottom: 0px m !important;
}

.label-box .gs-button-small {
  height: 20px;
  padding: 0 20px;
}
/deep/ .label-box .gs-form-item-label {
  line-height: 20px;
}
/deep/ .el-pager li.active {
  color: orange !important;
}
.el-pagination {
  text-align: center;
  margin-top: 10px;
}
.gs-radio-group .gs-radio {
  display: block;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/hkVideo/Index.vue